"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualReportArchiveBlock = exports.CompanyReportArchive = void 0;
const spa_core_1 = require("@episerver/spa-core");
const react_1 = __importStar(require("react"));
const Collapse_1 = __importDefault(require("react-bootstrap/Collapse"));
const react_redux_1 = require("react-redux");
require("./ReportArchiveBlocks.scss");
const CompanyReportArchive = (props) => {
    var _a, _b;
    const [scrollPos, setScrollPos] = (0, react_1.useState)(0);
    const [maxScroll, setMaxScroll] = (0, react_1.useState)(0);
    const [scrollStep, setScrollStep] = (0, react_1.useState)(0);
    const [leftActive, setLeftActive] = (0, react_1.useState)(false);
    const [rightActive, setRightActive] = (0, react_1.useState)(true);
    const [open, setOpen] = (0, react_1.useState)(props.openAsDefault);
    const scrollable = (0, react_1.useRef)(null);
    const scrollRefs = (0, react_1.useRef)([]);
    const years = (0, react_1.useRef)(null);
    const rows = [];
    const linkrows = [];
    let sortedLinks = [];
    const lang = (0, react_redux_1.useSelector)((state) => {
        var _a;
        return (_a = state.OptiContentCloud) === null || _a === void 0 ? void 0 : _a.currentLanguage;
    });
    const handleManualScroll = (e) => {
        const pos = e.target.scrollLeft;
        let changed = false;
        scrollRefs.current.forEach(el => {
            if (el.childElementCount !== 0 && el.scrollLeft !== pos) {
                changed = true;
            }
        });
        if (changed)
            setScrollPos(document.activeElement.offsetLeft);
    };
    if (props.documentRow) {
        (_b = (_a = props.documentRow) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.forEach(function (x, index) {
            const links = [];
            if (x.documentList) {
                sortedLinks = [].slice.call(x.documentList).sort((a, b) => {
                    if (a.documentLinkTitle > b.documentLinkTitle) {
                        return -1;
                    }
                    if (a.documentLinkTitle < b.documentLinkTitle) {
                        return 1;
                    }
                });
                sortedLinks.forEach(function (link) {
                    const openInNewWindow = link === null || link === void 0 ? void 0 : link.openInNewWindow;
                    // create heading rows
                    if (rows.filter(item => item.props.children === link.documentLinkTitle).length === 0) {
                        rows.push(react_1.default.createElement("div", { className: 'col-link d-flex justify-content-center', role: 'columnheader', key: (link.documentLinkTitle.replace(/[^a-z0-9]/gi, '') + props.title).replace(/\s/g, '') }, link.documentLinkTitle));
                    }
                    // create links
                    (link === null || link === void 0 ? void 0 : link.documentLink) != undefined ? links.push(react_1.default.createElement("div", { role: 'cell', className: 'col-link d-flex justify-content-center align-items-end', key: (x.title.replace(/[^a-z0-9]/gi, '') + link.documentLinkTitle).replace(/\s/g, '') },
                        react_1.default.createElement("a", { href: link.documentLink, download: link.documentLink.split('/').pop().indexOf('.') > 0 && !link.documentLink.endsWith('.html') && !link.documentLink.endsWith('.htm') ? link.documentLink.split('/').pop() : false, target: `${openInNewWindow || link.documentLink.endsWith('.html') || link.documentLink.endsWith('.htm') ? '_blank' : '_self'}` }, link.documentLinkTitle)))
                        : links.push(react_1.default.createElement("div", { role: 'cell', className: 'col-link d-flex justify-content-center nolink', key: (x.title.replace(/[^a-z0-9]/gi, '') + link.documentLinkTitle).replace(/\s/g, '') }, link.documentLinkTitle));
                });
            }
            linkrows.push(react_1.default.createElement("div", { className: `row document-row py-6 py-sm-5 ${(x === null || x === void 0 ? void 0 : x.useAsSubContent) ? 'sub-content' : ''}`, key: x.title, role: 'row' },
                react_1.default.createElement("div", { className: `col-document ${(x === null || x === void 0 ? void 0 : x.useAsSubContent) ? 'ps-sm-9' : ''}`, role: 'rowheader' },
                    x.title,
                    " ",
                    react_1.default.createElement("span", { "aria-hidden": true, className: `${x === null || x === void 0 ? void 0 : x.iconClass} px-1` })),
                react_1.default.createElement("div", { className: 'col-arrow', "aria-hidden": true }),
                react_1.default.createElement("div", { className: 'col-years d-flex align-items-center' },
                    react_1.default.createElement("div", { ref: (element) => { scrollRefs.current[index] = element; }, className: 'row scrollable', onScroll: () => handleManualScroll(window.event) }, links)),
                react_1.default.createElement("div", { className: 'col-arrow', "aria-hidden": true })));
        });
    }
    const scrollLeft = () => {
        setScrollStep(scrollable.current.clientWidth);
        scrollPos - scrollStep < 0 ? setScrollPos(0) : setScrollPos(scrollPos - scrollStep);
    };
    const scrollRight = () => {
        setScrollStep(scrollable.current.clientWidth);
        if (scrollPos + scrollStep < maxScroll) {
            setScrollPos(scrollPos + scrollStep);
        }
        else {
            setScrollPos(maxScroll);
        }
    };
    (0, react_1.useEffect)(() => {
        let isCancelled = false;
        //max scroll
        setMaxScroll(scrollable.current.scrollWidth);
        //calculate scroll step
        setScrollStep(scrollable.current.clientWidth);
        //update scroll
        scrollable.current.scrollTo(scrollPos, 0);
        scrollRefs.current.forEach(element => {
            element.scrollTo(scrollPos, 0);
        });
        scrollPos < scrollable.current.scrollWidth / 2 ? setRightActive(true) : setRightActive(false);
        scrollPos === 0 ? setLeftActive(false) : setLeftActive(true);
        if (years.current.clientWidth > scrollable.current.scrollWidth) {
            setLeftActive(false);
            setRightActive(false);
        }
        return () => {
            isCancelled = true;
        };
    }, [scrollPos]);
    return react_1.default.createElement("div", { className: 'mb-7', role: 'table' },
        react_1.default.createElement("div", { className: 'row heading-row py-4', role: 'row' },
            react_1.default.createElement("div", { className: 'col-document', role: 'rowheader' },
                react_1.default.createElement("button", { onClick: () => setOpen(!open), "aria-controls": props.title.value, "aria-expanded": open, className: 'm-0 p-0 d-flex align-items-baseline text-start' },
                    react_1.default.createElement("span", { className: 'icon-play d-inline-flex' }),
                    react_1.default.createElement("span", { className: 'ps-4' }, props.title.value))),
            react_1.default.createElement("div", { className: 'col-arrow d-none d-sm-flex justify-content-center' },
                react_1.default.createElement("button", { "aria-disabled": !leftActive, tabIndex: leftActive ? 0 : -1, className: leftActive ? 'active left' : 'left', onClick: () => scrollLeft() },
                    react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "11.301", height: "7.064", viewBox: "0 0 11.301 7.064" },
                        react_1.default.createElement("path", { d: "M8.473,5.65,4.236,1.414,0,5.65-1.414,4.236l5.651-5.65,5.651,5.65Z", transform: "translate(1.414 1.414)" })),
                    react_1.default.createElement("span", { className: 'visually-hidden' }, lang === 'fi' ? 'Taaksepäin' : 'Scroll back'))),
            react_1.default.createElement("div", { ref: years, className: 'col-years d-none d-sm-flex align-items-center' },
                react_1.default.createElement("div", { ref: scrollable, className: 'row scrollable' }, rows)),
            react_1.default.createElement("div", { className: 'col-arrow d-none d-sm-flex justify-content-start' },
                react_1.default.createElement("button", { "aria-disabled": !rightActive, tabIndex: rightActive ? 0 : -1, className: rightActive ? 'active right' : 'right', onClick: () => scrollRight() },
                    react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "11.301", height: "7.064", viewBox: "0 0 11.301 7.064" },
                        react_1.default.createElement("path", { d: "M8.473,5.65,4.236,1.414,0,5.65-1.414,4.236l5.651-5.65,5.651,5.65Z", transform: "translate(1.414 1.414)" })),
                    react_1.default.createElement("span", { className: 'visually-hidden' }, lang === 'fi' ? 'Eteenpäin' : 'Scroll forward')))),
        react_1.default.createElement(Collapse_1.default, { in: open, dimension: "height", children: react_1.default.createElement("div", { id: props.title.value.replace(/[^a-z0-9]/gi, ''), role: 'rowgroup' }, linkrows) }));
};
exports.CompanyReportArchive = CompanyReportArchive;
const AnnualReportArchiveBlock = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const styles = {};
    if (((_a = props.data.backgroundColor) === null || _a === void 0 ? void 0 : _a.value) && props.data.backgroundColor.value !== '')
        styles.backgroundColor = props.data.backgroundColor.value;
    let cssClasses = ['row', (_b = props.data.fontColor) === null || _b === void 0 ? void 0 : _b.value, (_c = props.data.bottomPadding) === null || _c === void 0 ? void 0 : _c.value, (_d = props.data.topPadding) === null || _d === void 0 ? void 0 : _d.value];
    return react_1.default.createElement("div", Object.assign({ className: 'annualReportArchiveBlock', "data-glenabled": (_e = props.data.enableGlossary) === null || _e === void 0 ? void 0 : _e.value }, (((_f = props.data.blockLanguage) === null || _f === void 0 ? void 0 : _f.value) !== '' ? { lang: (_g = props.data.blockLanguage) === null || _g === void 0 ? void 0 : _g.value } : null)),
        react_1.default.createElement("div", { className: cssClasses.join(' '), style: styles },
            react_1.default.createElement("div", { className: 'col-12' },
                ((_h = props.data.mainbody) === null || _h === void 0 ? void 0 : _h.value) && ((_j = props.data.mainbody) === null || _j === void 0 ? void 0 : _j.value) !== '' &&
                    react_1.default.createElement("div", { className: 'row' },
                        react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.data, field: "mainbody", className: 'headingArea col-12 px-0 pb-8 pb-sm-9 pt-7' })),
                react_1.default.createElement(exports.CompanyReportArchive, { documentRow: props.data.documentRow, title: props.data.title, openAsDefault: props.data.sampoOpenDefault.value }))));
};
exports.AnnualReportArchiveBlock = AnnualReportArchiveBlock;
exports.default = exports.AnnualReportArchiveBlock;
